import styled from 'styled-components';
import { DynamicButton } from '../../../components/inputs/dinamicButton';

export const CustomDynamicButton = styled(DynamicButton)`
  button {
    width: 160px;
  }
`;
